<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex sm6>
        <currency-list-select
          v-model="settings.currencyCode"
          @input="onSelectCurrency"
          :outlined="outlinedInputs"
        ></currency-list-select>
      </v-flex>
      <v-flex sm6>
        <taxes-list-select
          :tax-type="settings.taxType"
          @onSelectTaxType="onSelectTaxType($event)"
          :outlined="outlinedInputs"
        ></taxes-list-select>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex sm6>
        <v-text-field
          label="Account Code"
          v-model="settings.accountCode"
          @change="onChange"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-flex>
      <v-flex sm6>
        <v-text-field
          label="Accounts Department Code"
          v-model="settings.accountsDepartmentCode"
          @change="onChange"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-card>
      <v-card-title>Markup</v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-text-field
              type="number"
              label="Accommodation Markup"
              v-model.number="settings.accommodationMarkup"
              suffix="%"
              @change="onChange"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              type="number"
              label="Transport Markup"
              v-model.number="settings.transportMarkup"
              suffix="%"
              @change="onChange"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              type="number"
              label="Activities Markup"
              v-model.number="settings.activitiesMarkup"
              suffix="%"
              @change="onChange"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              type="number"
              label="Other Services Markup"
              v-model.number="settings.otherMarkup"
              suffix="%"
              @change="onChange"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              type="number"
              label="Travel Markup"
              v-model.number="settings.travelMarkup"
              suffix="%"
              @change="onChange"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              type="number"
              label="Package Markup"
              v-model.number="settings.packageMarkup"
              suffix="%"
              @change="onChange"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card class="mt-4">
      <v-card-title>Commision</v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-text-field
              type="number"
              label="Accommodation Commision"
              v-model.number="settings.accommodationCommision"
              suffix="%"
              @change="onChange"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              type="number"
              label="Transport Commision"
              v-model.number="settings.transportCommision"
              suffix="%"
              @change="onChange"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-col>

          <v-col>
            <v-text-field
              type="number"
              label="Activities Commision"
              v-model.number="settings.activitiesCommision"
              suffix="%"
              @change="onChange"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              type="number"
              label="Other Services Commision"
              v-model.number="settings.otherCommision"
              suffix="%"
              @change="onChange"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              type="number"
              label="Travel Commision"
              v-model.number="settings.travelCommision"
              suffix="%"
              @change="onChange"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              type="number"
              label="Package Commision"
              v-model.number="settings.packageCommision"
              suffix="%"
              @change="onChange"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              type="number"
              label="Charge Commission"
              v-model.number="settings.chargeCommission"
              suffix="%"
              @change="onChange"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <slot></slot>
    <div v-if="debug">{{ settings }}</div>
  </v-container>
</template>

<script>
import CurrencyListSelect from "../shared/CurrencyListSelect";
import TaxesListSelect from "../shared/TaxesListSelect";

export default {
  name: "AgentEditorFinances",

  components: {
    CurrencyListSelect,
    TaxesListSelect,
  },

  props: {
    clear: {
      type: Boolean,
      default: false,
    },
    financeSettings: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      debug: false,
      settings: { ...this.financeSettings },
      taxTypes: ["Standard Tax"],
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  methods: {
    onSelectCurrency(data) {
      this.onChange();
    },
    onSelectTaxType(data) {
      this.settings.taxType = data.description;
      this.onChange();
    },
    onChange() {
      this.$emit("changeFinanceSettings", { ...this.settings });
    },
  },

  watch: {
    financeSettings(data) {
      let financeSettings = { ...data };
      delete financeSettings.__typename;

      if (JSON.stringify(financeSettings) != JSON.stringify(this.settings)) {
        this.settings = financeSettings;
      }
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/gt/agents/AgentEditorFinances.vue